const TIMESTAMP_KEY = '__ybitOfflineTimestamp';

export class OfflineTimestamp {
  constructor(value = new Date()) {
    this.value = value instanceof Date ? value.toISOString() : new Date(value).toISOString();
  }

  toDate() {
    return new Date(this.value);
  }

  toMillis() {
    return this.toDate().getTime();
  }

  toJSON() {
    return { [TIMESTAMP_KEY]: this.value };
  }

  valueOf() {
    return this.toMillis();
  }

  static now() {
    return new OfflineTimestamp();
  }

  static fromDate(date) {
    return new OfflineTimestamp(date);
  }
}

export const markTimestamp = (value = new Date()) => new OfflineTimestamp(value).toJSON();

export const hydrateValue = (value) => {
  if (Array.isArray(value)) {
    return value.map(hydrateValue);
  }

  if (value && typeof value === 'object') {
    if (value[TIMESTAMP_KEY]) {
      return new OfflineTimestamp(value[TIMESTAMP_KEY]);
    }

    return Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [key, hydrateValue(entry)])
    );
  }

  return value;
};

export const serializeValue = (value) => {
  if (value instanceof OfflineTimestamp) {
    return value.toJSON();
  }

  if (value instanceof Date) {
    return value.toISOString();
  }

  if (Array.isArray(value)) {
    return value.map(serializeValue);
  }

  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [key, serializeValue(entry)])
    );
  }

  return value;
};

export const cloneForRead = (value) => hydrateValue(JSON.parse(JSON.stringify(serializeValue(value))));

export const timestampToComparable = (value) => {
  if (value instanceof OfflineTimestamp) return value.toMillis();
  if (value && typeof value.toDate === 'function') return value.toDate().getTime();
  if (typeof value === 'string') {
    const parsed = Date.parse(value);
    if (!Number.isNaN(parsed)) return parsed;
  }
  return value;
};

